<content>
    <section class="entry-inline-framed">
        <label>{{'consumos.reimpresiones.consumo' | translate}}</label> {{consumoId}}
    </section>
    <table>
        <thead>
            <tr>
                <th class="date">{{'consumos.reimpresiones.fecha' | translate}}</th>
                <th class="date">{{'consumos.reimpresiones.fechaReimp' | translate}}</th>
                <th class="number">{{'consumos.reimpresiones.numEtiquetas' | translate}}</th>
                <th class="number">{{'consumos.reimpresiones.kilosReimpresos' | translate}}</th>
                <th class="string">{{'consumos.reimpresiones.destino' | translate}}</th>
                <th class="actions"></th>
            </tr>
        </thead>
        <tbody *ngFor="let reimpresion of reimpresiones; let i = index">
            <tr>
                <td class="date">{{reimpresion.fechaIns | date:"dd/MM/yyyy H:mm:ss"}}</td>
                <td class="date">{{reimpresion.fechaReimpresion | date:"dd/MM/yyyy H:mm:ss"}}</td>
                <td class="number">{{reimpresion.etiquetasReimpresas | number : '1.0-0': defaultLanguage}}</td>
                <td class="number">{{reimpresion.kilosReimpresos | number : '1.2-2': defaultLanguage}}</td>
                <td class="string">{{reimpresion.paisDestinoISO3}}</td>
                <td class="actions">
                    <i class="fas fa-stream" app-click-stop-propagation (click)="showSection(i)" app-click-stop-propagation
                    title="{{dropdownSection === i ? ('global.minimizarDetalle' | translate) : ('global.mostrarDetalle' | translate)}}"></i>
                </td>
            </tr>
            <tr *ngIf="dropdownSection === i">
                <td colspan="1">
                  <section class="tabs">
                    <ul>
                      <li [ngClass]="{'active': pestanaActiva[i] === 1}" (click)="showSeriados(i)">{{'consumos.reimpresiones.seriado.titulo' | translate}}</li>
                    </ul>
                    <content>
                      <app-seriados-reimpresiones *ngIf="pestanaActiva[i] === 1" [seriados]="reimpresion.reimpresionSeriados"></app-seriados-reimpresiones>
                    </content>
                  </section>
                </td>
            </tr>
        </tbody>
        <tfoot *ngIf="!reimpresiones || (reimpresiones && reimpresiones.length < 1)">
            <tr>
                <td colspan="5">
                    {{'global.noContent' | translate}}
                </td>
            </tr>
        </tfoot>
    </table>
</content>
<footer class="button-bar-right">
    <button class="secondary" (click)="close()">{{'global.cerrar' | translate}}</button>
</footer>